//Hinweis war früher wms, war irreführend! Besser wäre MapService(maps) Unterscheidung via type 'WMS' oder 'TILE'
export const maps = {
    title: '',
    url: '',
    capabilitiesurl: 'https://sgx.geodatenzentrum.de/wms_basemapde?SERVICE=WMS&REQUEST=GetCapabilities&SERVICE=WMS&VERSION=1.3.0',
    layers: [],
    tilesurl: '',
    type: 'wms' 
};
